var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.declineReasons),function(item,index){return _c('div',{key:index},[_c('b-badge',{attrs:{"variant":"danger"}},[_vm._v(" "+_vm._s(item.ResultDescription)+" ")])],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }